<template>
 <div class="cont">
   <div>
    <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-tag iconFont" aria-hidden="true"></i>认证信息</span>
            </h4>
            <div class="box1">
              <div class="item"><span>企业名称：</span>{{registerInfo.companyName}}</div>
              <div class="item" ><span>营业执照号：</span>{{registerInfo.taxpayerNumber}}</div>
              <!-- <div class="item" ><span>道路运输经营许可证号：</span>{{registerInfo.transPermitno}}</div> -->
              <div class="item"><span>法人姓名：</span>{{registerInfo.legalPerson?registerInfo.legalPerson:'-'}}</div>
              <div class="item"><span>身份证号：</span>{{registerInfo.legalIdentityCard?registerInfo.legalIdentityCard:'-'}}</div>
              <div class="item"><span>身份证有效期：</span>{{registerInfo.legalIsLong==1?'长期':formatter(registerInfo.legalPersonidValidity,'yyyy-MM-dd') }}</div>
              <div class="item"><span>联系人：</span>{{registerInfo.contactsName}}</div>
              <div class="item"><span>联系电话：</span>{{registerInfo.contactsMoblie}}</div>
            </div>
        </div>
         <div class="addressBox" >
            <h4 class="title">
              <span><i class="fa fa-tag iconFont" aria-hidden="true"></i>证件照片</span>
            </h4>
            <div style="padding-left:20px">
            <ul class="ul" >
              <li  v-for="(item,index) in srcList"  :key="index">
                <el-image
                  fit="cover"
                  style="width: 150px; height: 150px"
                  :src="item"
                  :preview-src-list="getSrcList(index)"
                >
                </el-image>
              </li>
            </ul>
            <ul class="ul2">
              <li v-if="registerInfo.bsnsLicensepic != ''">营业执照</li>
              <li v-if="registerInfo.legalPersonpic1 !=''">身份证正面</li>
              <li v-if="registerInfo.legalPersonpic2 !=''">身份证背面</li>
            </ul>
            </div>
        </div>
    <div class="addressBox">
      <h4 class="title">
        <span style=" margin-right: 20px;"><i class="fa fa-tag iconFont" aria-hidden="true"></i>货物偏好</span>
        <el-button type="primary" @click="panhaoSave">保存</el-button>
      </h4>
      <div style="padding-left:20px;margin-bottom: 40px;">
         <el-tag
            v-for="item in productTypes"
            :key="item.id"
            type=""
            :effect="item.flag?'dark':'plain'" @click="pianhaoFN(item)">
            {{ item.name }}
            <i v-if="item.flag" class="el-icon-check"></i>
          </el-tag>
      </div>
    </div>
     <div class="addressBox">
        <h4 class="title">
          <span style=" margin-right: 20px;"><i class="fa fa-tag iconFont" aria-hidden="true"></i>常走路线</span>
          <el-button type="primary" @click="addsxFn">新增</el-button>
        </h4>
        <div style="padding-left:20px">
          <el-table :data="tableList"  ref="table" height="300px" style="width: 100%" center border>
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column  type="index" prop="date"  width="55" label="序号"></el-table-column>
          <el-table-column label="操作"  width="100">
              <template slot-scope="scope">
                <div>
                <el-button type="text" size="mini" @click="editFn(scope.row)">修改</el-button>
                <el-button type="text"   size="mini" @click="delFn(scope.row)">删除</el-button>
                </div>
              </template>
          </el-table-column>
          <el-table-column prop="startAreaName" label="起始地" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="endAreaName" label="目的地" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
        </div>
        <!-- 常走路线 -->
         <el-dialog :title="isAdd?'添加路线':'修改'" @close="closeDialog" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" width="400px" center>
            <span>
              <el-form :inline="true"  :model="addFrom" ref="addFrom" class="demo-form-inline jiaoyan" label-width="100px" size="mini">
              <div class="inpBox">
                <el-form-item label="起始地:" class="diqu is-required"  >
                  <shengShiXian :rowData="qishidi" @handleChange="handleChange" v-if="dialogVisible"></shengShiXian>
                </el-form-item>
                  <el-form-item label="目的地:" class="diqu is-required"  >
                  <shengShiXian :rowData="mudidi" @handleChange="handleChange1" v-if="dialogVisible"></shengShiXian>
                </el-form-item>
              </div>
              </el-form>
            </span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
            </span>
          </el-dialog>
      </div>
   </div>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { sTenantGetTenantDetailByCode } from '@/api/newCrm'
import { dropDownList } from '@/api/soc-stock'
import { cUsualLineList, cUsualLineAdd, cUsualLineUpdate, cUsualLineDelete, addOrUpdate, cPreferenceGoodsList } from '@/api/vgs-driver2.0'
import shengShiXian from '@/components/common/shengShiXian.vue'
export default {
  components: {
    shengShiXian
  },
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: ['000P00YB001', '000P00YB002'],
      registerInfo: {},
      srcList: [],
      productTypes: [],
      dialogVisible: false, // 常用地址
      isAdd: true,
      addFrom: {},
      qishidi: {},
      mudidi: {},
      tableList: [],
      row: {},
      goodsId: '',
      isCutCrm3: localStorage.getItem('isCutCrm3'),
      userType: localStorage.getItem('userType')// 1、平台自有用户 2、租户用户，3.平台挂靠车队长，4.平台挂靠司机
    }
  },
  created () {
    dropDownList().then(res => {
      cPreferenceGoodsList({ type: 1 }).then(res1 => {
        if (res1.length > 0) {
          this.goodsId = res1[0].id
          let arr = res1[0].goodsTypeIds.split(',')
          res.forEach(item => {
            item.flag = arr.some(a => item.id == a)
          })
        } else {
          res.forEach(item => {
            item.flag = false
          })
        }
        this.productTypes = res
      })
    })
    this.getList()
    this.getUserInfoV2()
    this.btnFlg = getBtn(this.btnIdArr, '/systemManagement/enterprise')
  },
  mounted () {

  },
  methods: {
    // 常用路线
    addsxFn () {
      if (this.tableList.length == 5) {
        this.$alert('最多只能添加5条常走路线', '系统提示')
        return
      }
      this.isAdd = true
      this.dialogVisible = true
    },
    editFn (row) {
      console.log(row)
      let codeArrQ = JSON.parse(row.startAreaCode)
      let nameArrQ = row.startAreaName.split('-')
      let codeArrZ = JSON.parse(row.endAreaCode)
      let nameArrZ = row.endAreaName.split('-')
      console.log(codeArrQ)
      this.qishidi.provinceCode = codeArrQ[0]
      this.qishidi.cityCode = codeArrQ[1]
      this.qishidi.areaCode = codeArrQ[2]
      this.qishidi.provinceName = nameArrQ[0]
      this.qishidi.cityName = nameArrQ[1]
      this.qishidi.areaName = nameArrQ[2]
      this.qishidi.id = 1
      this.mudidi.provinceCode = codeArrZ[0]
      this.mudidi.cityCode = codeArrZ[1]
      this.mudidi.areaCode = codeArrZ[2]
      this.mudidi.provinceName = nameArrZ[0]
      this.mudidi.cityName = nameArrZ[1]
      this.mudidi.areaName = nameArrZ[2]
      this.mudidi.id = 1
      this.isAdd = false
      this.dialogVisible = true
      this.row = row
    },
    // 地区选中
    handleChange (value) {
      if (value) {
        this.qishidi.provinceCode = value[0].areaCode
        this.qishidi.cityCode = value[1].areaCode
        this.qishidi.areaCode = value[2].areaCode
        this.qishidi.provinceName = value[0].name
        this.qishidi.cityName = value[1].name
        this.qishidi.areaName = value[2].name
      }
    },
    // 地区选中
    handleChange1 (value) {
      if (value) {
        this.mudidi.provinceCode = value[0].areaCode
        this.mudidi.cityCode = value[1].areaCode
        this.mudidi.areaCode = value[2].areaCode
        this.mudidi.provinceName = value[0].name
        this.mudidi.cityName = value[1].name
        this.mudidi.areaName = value[2].name
      }
    },
    saveFn () {
      if (!this.qishidi.provinceCode) {
        this.$alert('请选择起始地', '系统提示')
        return
      }
      if (!this.mudidi.provinceCode) {
        this.$alert('请选择目的地', '系统提示')
        return
      }
      let data = {
        type: 1,
        startAreaCode: '[' + this.qishidi.provinceCode + ',' + this.qishidi.cityCode + ',' + this.qishidi.areaCode + ']',
        startAreaName: this.qishidi.provinceName + '-' + this.qishidi.cityName + '-' + this.qishidi.areaName,
        endAreaCode: '[' + this.mudidi.provinceCode + ',' + this.mudidi.cityCode + ',' + this.mudidi.areaCode + ']',
        endAreaName: this.mudidi.provinceName + '-' + this.mudidi.cityName + '-' + this.mudidi.areaName
      }
      if (this.isAdd) {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        cUsualLineAdd(data).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getList()
          this.dialogVisible = false
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      } else {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        data.id = this.row.id
        cUsualLineUpdate(data).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getList()
          this.dialogVisible = false
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    getList () {
      cUsualLineList({ type: 1 }).then(res => { // '类型：1.车队，2. 司机，3.车队长',
        this.tableList = res
      })
    },
    delFn (row) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        cUsualLineDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    closeDialog () {
      this.qishidi = {}
      this.mudidi = {}
    },
    // 偏好货物
    pianhaoFN (item) {
      item.flag = !item.flag
    },
    panhaoSave () {
      let arrId = []
      let arrName = []
      this.productTypes.forEach(item => {
        if (item.flag) {
          arrId.push(item.id)
          arrName.push(item.name)
        }
      })
      if (arrId.length == 0) {
        this.$alert('请至少保留一种货物', '系统提示')
        cPreferenceGoodsList({ type: 1 }).then(res1 => {
          let arr = res1[0].goodsTypeIds.split(',')
          this.productTypes.forEach(item => {
            item.flag = arr.some(a => item.id == a)
          })
        })
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      addOrUpdate({ goodsTypeIds: arrId.toString(), goodsTypeNames: arrName.toString(), type: 1, id: this.goodsId }).then(res => {
        loading.close()
        this.$message({
          message: '操作成功',
          type: 'success'
        })
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    getUserInfoV2 () {
      sTenantGetTenantDetailByCode({ tenantCode: localStorage.getItem('tenantCode') }).then(res => {
        this.registerInfo = res
        if (this.registerInfo.bsnsLicensepicUrl != '') {
          this.srcList.push(this.registerInfo.bsnsLicensepicUrl)
        }
        if (this.registerInfo.legalPersonpic1 != '') {
          this.srcList.push(this.registerInfo.legalPersonpic1Url)
        }
        if (this.registerInfo.legalPersonpic2 != '') {
          this.srcList.push(this.registerInfo.legalPersonpic2Url)
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },

    // 点击图片放大
    getSrcList (index) {
      return this.srcList.slice(index).concat(this.srcList.slice(0, index))
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      // var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      // var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      // var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() + '-' + month + '-' + date
        // +
        // ' ' +
        // hour +
        // ':' +
        // minutes +
        // ':' +
        // seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    // 时间格式化
    formatter (thistime, fmt) {
      if (thistime) {
        let $this = new Date(thistime)
        let o = {
          'M+': $this.getMonth() + 1,
          'd+': $this.getDate(),
          'h+': $this.getHours(),
          'm+': $this.getMinutes(),
          's+': $this.getSeconds(),
          'q+': Math.floor(($this.getMonth() + 3) / 3),
          'S': $this.getMilliseconds()
        }
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(RegExp.$1, ($this.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
          }
        }
        return fmt
      } else {
        return '-'
      }
    }
  }
}
</script>

<style scoped lang='less'>
.cont{
  width: 100%;

}
.box1{
  font-size: 14px;
  display: flex;
 flex-wrap: wrap;
 padding-left: 16px;
 padding-bottom: 16px;
 .item{
   margin-right: 30px;
   margin-bottom: 16px;
   span{
     color: #757272;
   }

 }
}
 .addressBox{
  .ul {
    display: flex;
    // flex-wrap: wrap;
    height: 150px;
    li {
      width: 150px;
      height: 150px;
      border-radius: 20px;
      overflow: hidden;
      border: 1px dashed #ccc;
      margin-right: 30px;
      text-align: center;

      img {
        height: 100%;
        width: 100%;
      }
    }
  }
  .ul2 {
    display: flex;
    // flex-wrap: wrap;
    li {
      width: 150px;
      margin-right: 30px;
      font-size: 14px;
      text-align: center;
    }
  }
}
 .status{
    margin-left: 10px;
  }
  /deep/.el-tag{
    margin-right: 12px;
    margin-bottom: 12px;
    cursor: pointer;
  }
</style>
